import {Text} from "@fluentui/react-components";

export default function NotFoundPage() {
    return <>
        <Text>페이지를 찾을 수 없습니다.</Text>
    </>
}